<template>
    <main id="login" class="w-100 h-100">

        <div class="d-flex justify-content-center">
            <div
                class="content d-flex flex-column justify-content-center align-items-center"
                style="width: 45%; margin-top: 50px; transition: 1s all"
            >
                <div class="content-form" style="width: 60%">
                    <div>
                        <div style="display: flex; justify-content: space-between; align-items: center">
                            <img src="https://static.supsis.live/common/supsisAiLogo.png" style="width: 150px" />
                            <language-switch />
                        </div>
                    </div>
                    <div style="margin-top: 50px; color: #183b56; font-weight: 700; font-size: 35px">
                        <div style="line-height: 1">{{ $t("login.passwordForget") }}</div>
                    </div>
                    <div style="margin-top: 40px">
                        <div>
                            <span class="font-weight-bold" style="color: #183b56">{{ $t("login.email") }}</span>
                            <div style="margin-top: 3px">
                                <a-form-item
                                    has-feedback
                                    :validate-status="
                                        loginForm.email ? (!!errors.first('email') ? 'error' : 'success') : undefined
                                    "
                                    :help="
                                        loginForm.email && errors.first('email') ? $t('login.emailError') : undefined
                                    "
                                >
                                    <a-input
                                        ref="userNameInput"
                                        v-model="loginForm.email"
                                        v-validate="'required|email'"
                                        name="email"
                                        :class="{ error: !!errors.first('email') }"
                                        :placeholder="$t('login.emailPlaceholder')"
                                    >
                                        <a-icon slot="prefix" type="mail" />
                                    </a-input>
                                </a-form-item>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between" style="margin-top: 20px">
                            <div
                                class="w-100 text-center text-white font-weight-bold user-select-none"
                                style="border-radius: 8px; padding: 13px 0; font-size: 15px"
                                :style="{
                                    background: loginForm.email ? '#ec4b1d' : '#C3CAD9',
                                    cursor: loginForm.email ? 'pointer' : null,
                                }"
                                @click="loginForm.email ? doForgetPassword() : null"
                            >
                                {{ $t("login.passwordNew") }}
                            </div>
                        </div>
                        <div class="d-flex justify-content-between align-items-center" style="margin-top: 20px">
                            <hr color="#C3CAD9" width="50%" />
                            <div style="margin: 0px 5px; color: #183b56" width="100%">{{ $t("login.loginAnd") }}</div>
                            <hr color="#C3CAD9" width="50%" />
                        </div>
                        <div class="d-flex justify-content-between w-full" style="margin-top: 20px">
                            <router-link
                                to="/passwordless-login"
                                class="w-100 text-center text-white font-weight-bold"
                                style="background: #183b56; border-radius: 8px; padding: 13px 0; font-size: 15px"
                            >
                                {{ $t("login.emailLogin") }}
                            </router-link>
                        </div>
                        <div class="d-flex justify-content-between w-full" style="margin-top: 20px">
                            <router-link
                                to="/login"
                                class="w-100 text-center text-white font-weight-bold"
                                style="background: #183b56; border-radius: 8px; padding: 13px 0; font-weight: bold"
                            >
                                {{ $t("login.passwordAndLogin") }}
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { mapActions, mapState } from "vuex";
import PasswordForgot from "../../components/svg/PasswordForgot";
import LanguageSwitch from "../../components/LanguageSwitch";
import SupsisLogo from "../../components/svg/SupsisLogo.vue";

export default {
    name: "ForgotPassword",
    components: { PasswordForgot, LanguageSwitch, SupsisLogo },

    data() {
        return {
            loading: false,
            isSubmit: false,
            isClickable: true,
            loginForm: {
                email: "",
            },
        };
    },
    computed: {
        ...mapState({
            language: (state) => state.language.language,
        }),
    },
    methods: {
        ...mapActions({
            forgotPassword: "auth/forgotPassword",
        }),
        doForgetPassword() {
            if (!this.isClickable) {
                return;
            }

            this.isSubmit = true;
            this.$validator.validateAll().then((response) => {
                if (response) {
                    this.loading = true;
                    this.isClickable = false;
                    this.forgotPassword(this.loginForm)
                        .then((z) => {
                            this.$bvToast.toast(this.$t("message.forgetPasswordSent"), {
                                title: this.$t("message.successful"),
                                variant: "success",
                                solid: true,
                            });
                            setTimeout(() => {
                                this.isClickable = true;
                                this.$router.push("login");
                            }, 3000);
                        })
                        .catch((error) => {
                            if (error.response.data.localizedMessages) {
                                this.$bvToast.toast(
                                    this.language.code === "en"
                                        ? error.response.data.localizedMessages.en
                                        : error.response.data.localizedMessages.tr,
                                    {
                                        title: this.$t("message.error"),
                                        variant: "danger",
                                        solid: true,
                                    }
                                );
                            } else {
                                console.error("error --> ", error);
                                this.$bvToast.toast(error.response.data, {
                                    title: error.response.statusText || "Error",
                                    variant: "danger",
                                    solid: true,
                                });
                            }
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            });
        },
    },
};
</script>
<style scoped>
::-moz-selection {
    /* Code for Firefox */
    color: white !important;
    background: #ec4b1d !important;
}

::selection {
    color: white !important;
    background: #ec4b1d !important;
}

@media (max-width: 724px) {
    .content-form {
        width: 80% !important;
    }
}

@media (max-width: 950px) {
    .user-hash {
        flex-direction: row;
    }

    .content {
        flex-direction: row;
        width: 100% !important;
    }

    .right-side {
        display: none !important;
    }
}

.codeButton {
    background: #ec4b1d !important;
    color: white;
    border-radius: 5px !important;
    height: auto !important;
    padding: 11px 20px;
}

.codeButton:hover {
    border: 1px solid #ec4b1d !important;
}
</style>
